import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    AppBar,
    Toolbar,
    Hidden,
    Card,
    CardMedia,
    CardContent,
    Box,
    Fade
} from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import MenuIcon from '@material-ui/icons/Menu'
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    topHeaderContainer: {
        width: '100%',
        borderBottom: 'solid #159587',
        paddingTop: '65px',
        position: 'absolute',
        left: 0,
        zIndex: 2,
        backgroundColor: '#ffffff',
    },
    appBarContainer: {
        position: 'relative',
    },
    headerAppBar: {
        backgroundColor: 'transparent',
        display: 'block',
    },
    headerContainer: {
        display: 'block',
        width: '100%',
        position: 'relative',
        backgroundImage: 'url(/uob/main-banner-1.jpg)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top',
        backgroundSize: 'cover',
    },
    headerImg: {
        width: '100%',
        height: 'auto',
    },
    headerTitle: {
        position: 'absolute',
        textAlign: 'center',
        top: '40%',
        left: '50%',
        color: 'white',
        transform: 'translate(-50%, -50%);',
        width: '50%',
    },
    headerInfoBox: {
        backgroundColor: '#F4B04D',
        marginBottom: '50px',
        marginTop: '-15%',
        position: 'relative',
    },
    headerSubImg: {
        display: 'block',
        margin: '0 auto',
        marginBottom: '15px',
    },
    headerInfoBoxTitle: {
        fontWeight: '700',
        fontSize: '40px',
        lineHeight: '40px',
        textAlign: 'center',
        marginBottom: '10px',
    },
    headerInfoBoxSubTitle: {
        fontWeight: '700',
        fontSize: '20px',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
    },
}));

export default function Header() {
    const classes = useStyles();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

    const handleClick = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <>
            <div className={classes.topHeaderContainer}></div>
            <Container maxWidth="lg">
                <div className={classes.appBarContainer}>
                    <AppBar position="absolute" elevation={0} className={classes.headerAppBar}>
                            <Toolbar className="menu-toolbar-left">
                            
                        </Toolbar>
                        <Hidden smDown>
                            <Toolbar className="menu-toolbar-right">
                                <ul className="menu-container">
                                    <li className="menu-item"><Link to='/' >Home</Link></li>
                                    <li className="menu-item"><Link to='/contact' >Contact</Link></li>
                                </ul>
                            </Toolbar>
                        </Hidden>
                        <Hidden mdUp>
                            <Toolbar className="menu-toolbar-right">
                                <MenuIcon
                                    onClick={handleClick}
                                    style={{
                                        color: '#159587',
                                        cursor: 'pointer',
                                    }}
                                />
                            </Toolbar>
                        </Hidden>
                    </AppBar>
                </div>
                <Fade in={isMobileMenuOpen}>
                    <div className='menu-mobile'>
                        <ul>
                            <li><Link to='/' onClick={handleMenu} >Home</Link></li>
                            <li><Link to='/contact' onClick={handleMenu} >Contact</Link></li>
                        </ul>
                    </div>
                </Fade>
            </Container>
            <div className={classes.headerContainer}>
                <div className="header-text" >
                    UOB Cards x Getz
                    <br />
                    <div className="sub-header-text">
                        Enjoy great privileges on islandwide delivery, pick-up or 
                        <br />
                        dine-in across hundreds of your favourite restaurants with UOB Cards.
                    </div>
                </div>
                <Box className="header-services-container" >
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <Grid item container spacing={1}>
                                <Grid item xs={6}>
                                    <Card className="header-services-card" elevation={0}>
                                        <div className="header-services-card-title">
                                            Advance<br />Pickup
                                        </div>
                                        <div className="header-services-card-media">
                                            <CardMedia
                                                component="img"
                                                className="header-services-card-media"
                                                image="/uob/service-pickup.png"
                                                title="Advanced Pickup"
                                            />
                                        </div>
                                        <CardContent className="header-services-card-content">
                                            Order Ahead<br />No Queueing
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6}>
                                    <Card className="header-services-card" elevation={0}>
                                        <div className="header-services-card-title">
                                            Islandwide<br />Delivery
                                        </div>
                                        <div className="header-services-card-media">
                                            <CardMedia
                                                component="img"
                                                image="/uob/service-delivery.png"
                                                title="Islandwide Delivery"
                                            />
                                        </div>
                                        <CardContent className="header-services-card-content">
                                            Served to<br />your Doorstep
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6}>
                                    <div class="header-services-card-footer">
                                        Stay Tuned for More UOB Promotions!
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <div class="header-services-card-footer">
                                        Stay Tuned for More UOB Promotions!
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}> 
                            <Grid item container spacing={1}>
                                <Grid item xs={6}>
                                    <Card className="header-services-card" elevation={0}>
                                        <div className="header-services-card-title">
                                            Contactless<br />Dine-in
                                        </div>
                                        <div className="header-services-card-media">
                                            <CardMedia
                                                component="img"
                                                className="header-services-card-media"
                                                image="/uob/service-dinein.png"
                                                title="Dine-in"
                                            />
                                        </div>
                                        <CardContent className="header-services-card-content">
                                            Dine / Reserve<br />Contactlessly
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6}>
                                    <Card className="header-services-card" elevation={0}>
                                        <div className="header-services-card-title">
                                            Contactless<br />Take-out
                                        </div>
                                        <div className="header-services-card-media">
                                            <CardMedia
                                                component="img"
                                                className="header-services-card-media"
                                                image="/uob/service-queue.png"
                                                title="Take-away"
                                            />
                                        </div>
                                        <CardContent className="header-services-card-content">
                                            Beat the Queue<br />Contactlessly
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6}>
                                    <div class="header-services-card-footer">
                                        Stay Tuned for More UOB Promotions!
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <div class="header-services-card-footer">
                                        Stay Tuned for More UOB Promotions!
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <div class="header-powered-by-logo">
                    <img src="uob/ordersg-logo.png" alt="Powered by Getz" className="logo-img" />
                </div>
            </div>
        </>
    )
}